document.addEventListener('DOMContentLoaded', function() {
    const heroVideos = document.querySelectorAll('.mo-hero');
    heroVideos && heroVideos.forEach(function(heroVideo) {
        autoplayHeroVideo(heroVideo);
    });
    var iframes = document.querySelectorAll('.video-wrapper iframe');
    iframes && iframes.forEach(function(iframe) {
        var player = new Vimeo.Player(iframe);
        player.on('loaded', function() {
            Promise.all([player.getVideoWidth(), player.getVideoHeight()]).then(function(dimensions) {
                var width = dimensions[0];
                var height = dimensions[1];
                console.log('width: ', width);
                console.log('height: ', height);
                
                
                //if (width < height) {
                    iframe.parentElement.style.paddingBottom = (height / width) * 100 + '%';
               /* } else {
                    console.log((width / height) * 100 + '%');
                    
                    iframe.parentElement.style.paddingBottom = (width / height) * 100 + '%';
                }*/
            })
            
        });
    });
    
});

function playHeroVideo(moduleContainer) {
    const iframe = moduleContainer.querySelector('iframe');
    if(!iframe) return;
    const player = new Vimeo.Player(iframe);
    if(!player) return;
    player.play();
}

function autoplayHeroVideo(moduleContainer) {
    // Play video after couple of seconds
    const poster = moduleContainer.querySelector('.poster');
    if(poster) {
        setTimeout(function() {
            poster.style.display = 'none';
            playHeroVideo(moduleContainer);
        }, 2000);
    } else {
        playHeroVideo(moduleContainer);
    }
}
